import { OTHER_CATEGORY_KEY } from '@shared/utils/permissionsCatalog'
import {
  Box,
  Car,
  Card,
  DocumentText,
  Element3,
  Eye,
  Key,
  ReceiptItem,
  Setting2,
  ShieldTick
} from 'iconsax-react'

type IconComponent = typeof Key

const CATEGORY_ICONS: Record<string, IconComponent> = {
  sections: Element3,
  main_sections: Element3,
  data_visibility: Eye,
  visibility: Eye,
  order_actions: DocumentText,
  orders: DocumentText,
  financial_actions: Card,
  financial: Card,
  ecec: ReceiptItem,
  e_cec: ReceiptItem,
  rca: Car,
  rca_management: Car,
  rca_policies: Car,
  settings: Setting2,
  claims: ShieldTick,
  despagubiri: ShieldTick,
  products: Box,
  [OTHER_CATEGORY_KEY]: Key
}

const FALLBACK_ICON = Key

export const CategoryIcon = ({ sectionKey }: { sectionKey: string }) => {
  const categoryKey = sectionKey.slice(sectionKey.indexOf(':') + 1)
  const Icon = CATEGORY_ICONS[categoryKey] ?? FALLBACK_ICON

  return <Icon size={18} variant="Bulk" />
}
